import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const benefits = ['Fase de estabilización para frenar las peleas hoy', 'Ejercicios de reconexión emocional y perdón', 'Guía para que el estrés financiero no rompa la confianza', "El 'Contrato de Convivencia en Crisis' — plantilla descargable", 'Plan S.O.S de Emergencia para momentos de tensión', "Mapa de 'Micro-Oasis' para recuperar la intimidad sin gastar"];
export function UniqueMechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038]" data-id="element-229">
      <div className="max-w-4xl mx-auto px-6" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-231">
          <div className="text-center mb-16" data-id="element-232">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-serif" data-id="element-233">
              Lo que vas a encontrar dentro del material
            </h2>
          </div>

          <div className="bg-[#E0D7FF] rounded-[20px] border border-white p-8 md:p-14 shadow-[0_10px_40px_-15px_rgba(124,58,237,0.15)]" data-id="element-234">
            <ul className="space-y-8" data-id="element-235">
              {benefits.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.5,
              delay: index * 0.1,
              ease: 'easeOut'
            }} className="flex items-start gap-5" data-id="element-236">
                  <div className="w-6 h-6 rounded-full bg-[#7C3AED]/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-237">
                    <CheckIcon className="w-4 h-4 text-[#7C3AED]" strokeWidth={3} data-id="element-238" />
                  </div>
                  <span className="text-lg md:text-xl text-[#1E0A3C] font-medium leading-relaxed font-sans" data-id="element-239">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}